import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/shared/_services';
import { DashboardStore, TransactionsStore } from 'src/app/shared/_services/store';

@Component({
  selector: 'app-general',
  templateUrl: 'general.component.html',
  styleUrls: ['general.component.scss'],
  providers: [DatePipe]
})
export class GeneralPage implements OnInit {
  today = Date.now();
  epochDateTime = new Date ().getTime();
  datePickerValue: any;
  todayDate: string;
  pickerDate = this.dashboardStore.getPickerDate();
  balance = this.dashboardStore.getBalance();
  generalReportsDetails = this.transactionsStore.getGeneralReports();
  gettingReports = false;

  constructor(
    private datePipe: DatePipe,
    private auth: AuthenticationService,
    private dashboardStore: DashboardStore,
    private transactionsStore: TransactionsStore
) {}

  changeDate(ev: any) {
    const date = ev.detail.value;
    this.epochDateTime = new Date (date).getTime();
    this.todayDate = this.datePipe.transform(this.today, 'yyyy-MM-dd');
    this.pickerDate = this.datePipe.transform(this.epochDateTime, 'yyyy-MM-dd');

    const dateText = document.getElementById('general-date-text');
    const dateTextInner: HTMLElement = dateText.shadowRoot.querySelector('.datetime-text');
    dateTextInner.innerText = new Date (this.epochDateTime).toDateString();
    this.dashboardStore.setPickerDate(this.pickerDate);

    this.getGeneralReports();

    if (this.todayDate === this.pickerDate) { dateTextInner.innerText = 'Today'; } else  { return; }
  }

  getGeneralReports() {
    this.gettingReports = true;
    this.auth.getGeneralReports(this.pickerDate)
    .subscribe(
      (response: any) => {
        this.gettingReports = false;
        console.log(response);
        this.transactionsStore.setGeneralReports(response);
        this.generalReportsDetails = this.transactionsStore.getGeneralReports();
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  ionViewWillLeave() {
  }

  ngOnInit() {
    this.pickerDate = this.datePipe.transform(this.today, 'yyyy-MM-dd');
    this.getGeneralReports();
  }

}
